import { ResourceMediaControlOptions } from '../../../models/component-options/resource-media-control.options';
import { CaptureType } from '../../panorama-tour/model/report-image.model';
import { ReportImageModel } from './report-image.model';
import { SmartTagFormModel } from './smart-tag-form.model';

export class ResourceMediaModel {
	public captureType?: CaptureType;
	public formModelType: FormModelType;
	public snapshot?: Snapshot;
	public isImageless?: boolean;
	public jsonPathSufix?: string;

	constructor() {
		this.captureType = null;
		this.snapshot = new Snapshot();
		this.isImageless = false;
		this.jsonPathSufix = '.smartTags'
		// Create By Default
		this.formModelType = FormModelType.CREATE;
	}
}

/**
 * Control All about the Snapshot Image
 * This is not always required, for example when editing a Smart Tag
 */
export class Snapshot {
	public preview?: boolean;
	public photoType?: string;

	// Image from Memory
	public blob?: any; // The Blog Image
	public requestedBlob?: boolean;
	public renderer?: any; // WebGLRenderer
	// Image from URL
	public url?: string | ArrayBuffer;
	public metadata?: any;

	constructor() {
		this.preview = false;
		this.requestedBlob = false;
		this.blob = null;
		this.renderer = null;
		this.url = null;
		this.metadata = null;
	}
}

export class ResourceModel {
	public blob: any;
	public targetPath: string;
	public metadata: any

	public reportImage?: ReportImageModel;
	public smartTagForm?: SmartTagFormModel;

	public options?: ResourceMediaControlOptions;

	constructor() {
		this.blob = null;
		this.targetPath = null;
		this.metadata = null;

		this.reportImage = null;
		this.smartTagForm = null;
	}
}

export enum FormModelType {
	CREATE,
	EDIT
}
